export enum FrequencyType {
  Daily = 1, // Deprecated - kept for backward compatibility, converted to Weekly on load
  Weekly = 2,
  Custom = 3,
}

export enum DurationType {
  Seconds = 1,
  Minutes = 2,
  Hours = 3,
  Days = 4,
}

export enum OrderFilterParams {
  PatientName = "patient_lname|patient_fname",
  OrderOrPatientName = "q", // 'q' value can either be full order id (order_num) or partial/full patient first/last name
}

export enum OrderStatus {
  Opened = 1,
  Cancelled = 2,
}

export enum OrderExpiration {
  ExpiresToday = 1,
  ExpiresInOneWeek = 2,
  ExpiresInTwoWeeks = 3,
  RecentlyExpired = 4,
}

export enum OrderAction {
  Create = 1,
  Update = 2,
  Cancel = 3,
  VoidRequest = 4,
  Void = 5,
  VoidRequestRejected = 6,
}

// order.cancel_type - how an order was closed, or that a void is pending. null - not cancelled
export enum OrderCancelType {
  Cancelled = 1, // status Cancelled, billed through the current cycle
  VoidRequested = 2, // status stays Opened until a global admin reviews it
  Voided = 3, // status Cancelled, created in error, uninvoiced charges removed
}

export enum OrderVoidAction {
  Void = "void",
  Request = "request",
}

export enum OrderModalState {
  Initial = 1,
  InProgress = 2,
  Submitted = 3,
}

export enum PayerType {
  Commercial = 1,
  Medicare = 2,
  Medicaid = 3,
  PersonalInjury = 4,
  SelfPay = 5,
  WorkersCompensation = 6,
  MedicareAdvantage = 7,
}
